import videojs, { VideoJsPlayer } from "video.js";
import { IOptions, CSSStyle } from "../type";

const Component = videojs.getComponent("Component");

export class BaseDiv extends Component {
  constructor(player: VideoJsPlayer, opts?: IOptions) {
    super(player, opts);
    videojs.dom.emptyEl(this.el());
  }

  createEl(): Element {
    return videojs.dom.createEl("div", {
      className: "vjs-default-div",
    });
  }

  setStyle(css?: CSSStyle): void {
    let styleStr = "";
    if (css) {
      for (const key in css) {
        styleStr += `${key}:${css[key as keyof CSSStyle]};`;
      }
    }
    this.setAttribute("style", styleStr);
  }
}
